export default __webpack_public_path__ + "static/pro-zhamak-dehghani-4c277b072a37959366913baeb00c8932.jpg";